import * as angular from 'angular';

export class AbilityServiceAjs {
  static $inject = ['LocalStoreService'];

  constructor(private LocalStoreService: any) {}

  // check user action
  listOfPermissions = (currentUser, actions) => {
    var canAccess = false;

    actions.map(function (action) {
      if (currentUser.role_info.permissions[action]) {
        // user_role[0]
        canAccess = true;
      }
    });

    return canAccess;
  };

  getTotalAddonResources = (currentAccount, feature) => {
    var totalUnits = 0;
    for (var i = 0; i < currentAccount.account_plan_addons.length; i++) {
      var accountPlanAddon = currentAccount.account_plan_addons[i];

      // Only active addons -  && accountPlanAddon.status
      if (accountPlanAddon.feature.name_key === feature) {
        totalUnits = totalUnits + accountPlanAddon.total_units;
      }
    }

    return totalUnits;
  };

  can(action) {
    const data = JSON.parse(this.LocalStoreService.get('cu'));

    if (!data) return false;

    let currentUser = data.user_info;

    let canAccess = false;

    if (Array.isArray(action)) {
      canAccess = this.listOfPermissions(currentUser, action);
    } else {
      if (currentUser && currentUser.role_info && currentUser.role_info.permissions[action]) {
        canAccess = true;
      }
    }

    return canAccess;
  }

  canFeature(feature, totalResourcesConsumed) {
    const data = JSON.parse(this.LocalStoreService.get('cu'));

    if (!data) {
      return false;
    }

    var currentUser = data.user_info;
    var currentAccount = currentUser.account_info;

    var canAccess = {
      permitted: false,
      name: '',
      type: '',
      visible_as_addon: false,
      totalResourcesConsumed: 0,
      totalResouresPermitted: 0,
    };

    if (currentUser && !currentUser.sd) {
      // AccountAdmin
      for (var i = 0; i < currentAccount.account_plan_features.length; i++) {
        var accountPlanFeature = currentAccount.account_plan_features[i];

        canAccess = {
          permitted: false,
          name: '',
          type: '',
          visible_as_addon: false,
          totalResourcesConsumed: 0,
          totalResouresPermitted: 0,
        };

        if (accountPlanFeature.feature.name_key === feature) {
          if (accountPlanFeature.feature.type === 'available' && !accountPlanFeature.available) {
            canAccess.permitted = false;
          } else {
            canAccess.name = accountPlanFeature.feature.name;
            canAccess.type = accountPlanFeature.feature.type;
            canAccess.visible_as_addon = true;

            var totalResouresPermitted =
              accountPlanFeature.total_units + this.getTotalAddonResources(currentAccount, feature);

            canAccess.totalResourcesConsumed = totalResourcesConsumed;
            canAccess.totalResouresPermitted = totalResouresPermitted;

            canAccess.permitted =
              totalResourcesConsumed < totalResouresPermitted ||
              totalResourcesConsumed === undefined
                ? true
                : false;
          }
          break;
        }
      }
    } else {
      canAccess.permitted = true; // temporary beacuse we need to canfeature master user roles
    }

    return canAccess;
  }

  // When there's no account in localstorage
  /* hasPermission(permission) {
    var currentAccount = this.LocalStoreService.get('cu');
    if (currentAccount) {
      return this.can(permission);
    }

    var user = this.LocalStoreService.get('cu');
    if (user && user.roles > 1) {
      if (user.roles[0].actions.indexOf(permission) > -1) {
        return true;
      }
    }
    return false;
  } */
}
